import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LeadDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LeadDeleteMutation = { __typename?: 'Mutation', leadDelete: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };

export type LeadPublishUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LeadPublishUpdateMutation = { __typename?: 'Mutation', leadPublishUpdate: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };

export type LeadSaveMutationVariables = Types.Exact<{
  leadInput: Types.LeadInput;
}>;


export type LeadSaveMutation = { __typename?: 'Mutation', leadSave?: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } | null };

export type LeadUpdateMutationVariables = Types.Exact<{
  leadInput: Types.LeadInputWithId;
}>;


export type LeadUpdateMutation = { __typename?: 'Mutation', leadUpdate: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };

export type LeadQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type LeadQuery = { __typename?: 'Query', lead?: { __typename?: 'Lead', id: string } | null };

export type LeadAllQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LeadAllQuery = { __typename?: 'Query', leadAll?: Array<{ __typename?: 'LeadDto', value: string, label: string }> | null };

export type LeadStatusesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LeadStatusesQuery = { __typename?: 'Query', leadStatuses: Array<{ __typename?: 'StatusLead', label: string, value: Types.LeadStatus }> };

export type LeadSourcesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type LeadSourcesQuery = { __typename?: 'Query', leadSources: Array<{ __typename?: 'SourceLead', label: string, value: Types.LeadSource }> };

export type LeadsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['ID']>;
  before?: Types.InputMaybe<Types.Scalars['ID']>;
  filter?: Types.InputMaybe<Types.LeadFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type LeadsQuery = { __typename?: 'Query', leads?: { __typename?: 'LeadConnection', edges: Array<{ __typename?: 'LeadEdge', cursor: string, node?: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null } | null }>, pageInfo?: { __typename?: 'PageInfo', endCursor: string, hasNextPage?: boolean | null, startCursor: string } | null } | null };

export type LeadsForTeamQueryVariables = Types.Exact<{
  team: Types.Scalars['ID'];
}>;


export type LeadsForTeamQuery = { __typename?: 'Query', leadsForTeam?: Array<{ __typename?: 'LeadDto', value: string, label: string }> | null };

export type LeadVisitedFirstTrainingMutationVariables = Types.Exact<{
  input: Types.LeadVisitedFirstTrainingInput;
}>;


export type LeadVisitedFirstTrainingMutation = { __typename?: 'Mutation', leadVisitedFirstTraining: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };

export type NoviceVisitedFirstTrainingMutationVariables = Types.Exact<{
  input: Types.NoviceVisitedFirstTrainingInput;
}>;


export type NoviceVisitedFirstTrainingMutation = { __typename?: 'Mutation', noviceVisitedFirstTraining: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };

export type LeadsForTrainingQueryVariables = Types.Exact<{
  training: Types.Scalars['ID'];
}>;


export type LeadsForTrainingQuery = { __typename?: 'Query', leadsForTraining?: Array<{ __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }> | null };

export type UpdateLeadCancelFirstTrainingMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type UpdateLeadCancelFirstTrainingMutation = { __typename?: 'Mutation', updateLeadCancelFirstTraining: { __typename?: 'LeadPayload', recordId: string, record: { __typename?: 'Lead', description?: string | null, id: string, name: string, nextVisitId?: string | null, phone?: string | null, published: boolean, source?: Types.LeadSource | null, status?: Types.LeadStatus | null, studentId?: string | null, staffId?: string | null, teamId?: string | null, yearBorn?: number | null, nextVisit?: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } | null, student?: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null } | null, staff?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, team?: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null }, errors?: Array<{ __typename?: 'LeadDoesNotExistsProblem', message: string } | { __typename?: 'LeadExistInOtherComponentsProblem', component: string, message: string } | { __typename?: 'LeadSaveProblem', message: string } | { __typename?: 'LeadUpdateProblem', message: string }> | null } };


export const LeadDeleteDocument = gql`
    mutation leadDelete($id: ID!) {
  leadDelete(id: $id) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type LeadDeleteMutationFn = Apollo.MutationFunction<LeadDeleteMutation, LeadDeleteMutationVariables>;

/**
 * __useLeadDeleteMutation__
 *
 * To run a mutation, you first call `useLeadDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadDeleteMutation, { data, loading, error }] = useLeadDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadDeleteMutation(baseOptions?: Apollo.MutationHookOptions<LeadDeleteMutation, LeadDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadDeleteMutation, LeadDeleteMutationVariables>(LeadDeleteDocument, options);
      }
export type LeadDeleteMutationHookResult = ReturnType<typeof useLeadDeleteMutation>;
export type LeadDeleteMutationResult = Apollo.MutationResult<LeadDeleteMutation>;
export type LeadDeleteMutationOptions = Apollo.BaseMutationOptions<LeadDeleteMutation, LeadDeleteMutationVariables>;
export const LeadPublishUpdateDocument = gql`
    mutation leadPublishUpdate($id: ID!) {
  leadPublishUpdate(id: $id) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type LeadPublishUpdateMutationFn = Apollo.MutationFunction<LeadPublishUpdateMutation, LeadPublishUpdateMutationVariables>;

/**
 * __useLeadPublishUpdateMutation__
 *
 * To run a mutation, you first call `useLeadPublishUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadPublishUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadPublishUpdateMutation, { data, loading, error }] = useLeadPublishUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadPublishUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LeadPublishUpdateMutation, LeadPublishUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadPublishUpdateMutation, LeadPublishUpdateMutationVariables>(LeadPublishUpdateDocument, options);
      }
export type LeadPublishUpdateMutationHookResult = ReturnType<typeof useLeadPublishUpdateMutation>;
export type LeadPublishUpdateMutationResult = Apollo.MutationResult<LeadPublishUpdateMutation>;
export type LeadPublishUpdateMutationOptions = Apollo.BaseMutationOptions<LeadPublishUpdateMutation, LeadPublishUpdateMutationVariables>;
export const LeadSaveDocument = gql`
    mutation leadSave($leadInput: LeadInput!) {
  leadSave(leadInput: $leadInput) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type LeadSaveMutationFn = Apollo.MutationFunction<LeadSaveMutation, LeadSaveMutationVariables>;

/**
 * __useLeadSaveMutation__
 *
 * To run a mutation, you first call `useLeadSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadSaveMutation, { data, loading, error }] = useLeadSaveMutation({
 *   variables: {
 *      leadInput: // value for 'leadInput'
 *   },
 * });
 */
export function useLeadSaveMutation(baseOptions?: Apollo.MutationHookOptions<LeadSaveMutation, LeadSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadSaveMutation, LeadSaveMutationVariables>(LeadSaveDocument, options);
      }
export type LeadSaveMutationHookResult = ReturnType<typeof useLeadSaveMutation>;
export type LeadSaveMutationResult = Apollo.MutationResult<LeadSaveMutation>;
export type LeadSaveMutationOptions = Apollo.BaseMutationOptions<LeadSaveMutation, LeadSaveMutationVariables>;
export const LeadUpdateDocument = gql`
    mutation leadUpdate($leadInput: LeadInputWithId!) {
  leadUpdate(leadInput: $leadInput) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type LeadUpdateMutationFn = Apollo.MutationFunction<LeadUpdateMutation, LeadUpdateMutationVariables>;

/**
 * __useLeadUpdateMutation__
 *
 * To run a mutation, you first call `useLeadUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadUpdateMutation, { data, loading, error }] = useLeadUpdateMutation({
 *   variables: {
 *      leadInput: // value for 'leadInput'
 *   },
 * });
 */
export function useLeadUpdateMutation(baseOptions?: Apollo.MutationHookOptions<LeadUpdateMutation, LeadUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadUpdateMutation, LeadUpdateMutationVariables>(LeadUpdateDocument, options);
      }
export type LeadUpdateMutationHookResult = ReturnType<typeof useLeadUpdateMutation>;
export type LeadUpdateMutationResult = Apollo.MutationResult<LeadUpdateMutation>;
export type LeadUpdateMutationOptions = Apollo.BaseMutationOptions<LeadUpdateMutation, LeadUpdateMutationVariables>;
export const LeadDocument = gql`
    query lead($id: ID!) {
  lead(id: $id) {
    id
  }
}
    `;

/**
 * __useLeadQuery__
 *
 * To run a query within a React component, call `useLeadQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLeadQuery(baseOptions: Apollo.QueryHookOptions<LeadQuery, LeadQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadQuery, LeadQueryVariables>(LeadDocument, options);
      }
export function useLeadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadQuery, LeadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadQuery, LeadQueryVariables>(LeadDocument, options);
        }
export type LeadQueryHookResult = ReturnType<typeof useLeadQuery>;
export type LeadLazyQueryHookResult = ReturnType<typeof useLeadLazyQuery>;
export type LeadQueryResult = Apollo.QueryResult<LeadQuery, LeadQueryVariables>;
export function refetchLeadQuery(variables: LeadQueryVariables) {
      return { query: LeadDocument, variables: variables }
    }
export const LeadAllDocument = gql`
    query leadAll {
  leadAll {
    value
    label
  }
}
    `;

/**
 * __useLeadAllQuery__
 *
 * To run a query within a React component, call `useLeadAllQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadAllQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadAllQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeadAllQuery(baseOptions?: Apollo.QueryHookOptions<LeadAllQuery, LeadAllQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadAllQuery, LeadAllQueryVariables>(LeadAllDocument, options);
      }
export function useLeadAllLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadAllQuery, LeadAllQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadAllQuery, LeadAllQueryVariables>(LeadAllDocument, options);
        }
export type LeadAllQueryHookResult = ReturnType<typeof useLeadAllQuery>;
export type LeadAllLazyQueryHookResult = ReturnType<typeof useLeadAllLazyQuery>;
export type LeadAllQueryResult = Apollo.QueryResult<LeadAllQuery, LeadAllQueryVariables>;
export function refetchLeadAllQuery(variables?: LeadAllQueryVariables) {
      return { query: LeadAllDocument, variables: variables }
    }
export const LeadStatusesDocument = gql`
    query leadStatuses {
  leadStatuses {
    label
    value
  }
}
    `;

/**
 * __useLeadStatusesQuery__
 *
 * To run a query within a React component, call `useLeadStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeadStatusesQuery(baseOptions?: Apollo.QueryHookOptions<LeadStatusesQuery, LeadStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadStatusesQuery, LeadStatusesQueryVariables>(LeadStatusesDocument, options);
      }
export function useLeadStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadStatusesQuery, LeadStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadStatusesQuery, LeadStatusesQueryVariables>(LeadStatusesDocument, options);
        }
export type LeadStatusesQueryHookResult = ReturnType<typeof useLeadStatusesQuery>;
export type LeadStatusesLazyQueryHookResult = ReturnType<typeof useLeadStatusesLazyQuery>;
export type LeadStatusesQueryResult = Apollo.QueryResult<LeadStatusesQuery, LeadStatusesQueryVariables>;
export function refetchLeadStatusesQuery(variables?: LeadStatusesQueryVariables) {
      return { query: LeadStatusesDocument, variables: variables }
    }
export const LeadSourcesDocument = gql`
    query leadSources {
  leadSources {
    label
    value
  }
}
    `;

/**
 * __useLeadSourcesQuery__
 *
 * To run a query within a React component, call `useLeadSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useLeadSourcesQuery(baseOptions?: Apollo.QueryHookOptions<LeadSourcesQuery, LeadSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadSourcesQuery, LeadSourcesQueryVariables>(LeadSourcesDocument, options);
      }
export function useLeadSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadSourcesQuery, LeadSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadSourcesQuery, LeadSourcesQueryVariables>(LeadSourcesDocument, options);
        }
export type LeadSourcesQueryHookResult = ReturnType<typeof useLeadSourcesQuery>;
export type LeadSourcesLazyQueryHookResult = ReturnType<typeof useLeadSourcesLazyQuery>;
export type LeadSourcesQueryResult = Apollo.QueryResult<LeadSourcesQuery, LeadSourcesQueryVariables>;
export function refetchLeadSourcesQuery(variables?: LeadSourcesQueryVariables) {
      return { query: LeadSourcesDocument, variables: variables }
    }
export const LeadsDocument = gql`
    query leads($after: ID, $before: ID, $filter: LeadFilter, $first: Int, $last: Int) {
  leads(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        description
        id
        name
        nextVisit {
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          published
          stadium {
            id
            latitude
            longitude
            name
            placeId
            published
          }
          stadiumId
          team {
            ages
            coachIds
            headCoachId
            id
            name
            placeId
            published
            writable
          }
          teamId
          time
          visits
        }
        nextVisitId
        phone
        published
        source
        status
        student {
          birthday
          creatorIds
          creators {
            id
            name
            phone
            published
            userId
          }
          id
          fileName
          name
          passportNum
          paymentSum
          published
          teamIds
          teams {
            ages
            coachIds
            headCoachId
            id
            name
            placeId
            published
            writable
          }
        }
        studentId
        staff {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        staffId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        yearBorn
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
  }
}
    `;

/**
 * __useLeadsQuery__
 *
 * To run a query within a React component, call `useLeadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useLeadsQuery(baseOptions?: Apollo.QueryHookOptions<LeadsQuery, LeadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadsQuery, LeadsQueryVariables>(LeadsDocument, options);
      }
export function useLeadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadsQuery, LeadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadsQuery, LeadsQueryVariables>(LeadsDocument, options);
        }
export type LeadsQueryHookResult = ReturnType<typeof useLeadsQuery>;
export type LeadsLazyQueryHookResult = ReturnType<typeof useLeadsLazyQuery>;
export type LeadsQueryResult = Apollo.QueryResult<LeadsQuery, LeadsQueryVariables>;
export function refetchLeadsQuery(variables?: LeadsQueryVariables) {
      return { query: LeadsDocument, variables: variables }
    }
export const LeadsForTeamDocument = gql`
    query leadsForTeam($team: ID!) {
  leadsForTeam(team: $team) {
    value
    label
  }
}
    `;

/**
 * __useLeadsForTeamQuery__
 *
 * To run a query within a React component, call `useLeadsForTeamQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsForTeamQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsForTeamQuery({
 *   variables: {
 *      team: // value for 'team'
 *   },
 * });
 */
export function useLeadsForTeamQuery(baseOptions: Apollo.QueryHookOptions<LeadsForTeamQuery, LeadsForTeamQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadsForTeamQuery, LeadsForTeamQueryVariables>(LeadsForTeamDocument, options);
      }
export function useLeadsForTeamLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadsForTeamQuery, LeadsForTeamQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadsForTeamQuery, LeadsForTeamQueryVariables>(LeadsForTeamDocument, options);
        }
export type LeadsForTeamQueryHookResult = ReturnType<typeof useLeadsForTeamQuery>;
export type LeadsForTeamLazyQueryHookResult = ReturnType<typeof useLeadsForTeamLazyQuery>;
export type LeadsForTeamQueryResult = Apollo.QueryResult<LeadsForTeamQuery, LeadsForTeamQueryVariables>;
export function refetchLeadsForTeamQuery(variables: LeadsForTeamQueryVariables) {
      return { query: LeadsForTeamDocument, variables: variables }
    }
export const LeadVisitedFirstTrainingDocument = gql`
    mutation leadVisitedFirstTraining($input: LeadVisitedFirstTrainingInput!) {
  leadVisitedFirstTraining(input: $input) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type LeadVisitedFirstTrainingMutationFn = Apollo.MutationFunction<LeadVisitedFirstTrainingMutation, LeadVisitedFirstTrainingMutationVariables>;

/**
 * __useLeadVisitedFirstTrainingMutation__
 *
 * To run a mutation, you first call `useLeadVisitedFirstTrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeadVisitedFirstTrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leadVisitedFirstTrainingMutation, { data, loading, error }] = useLeadVisitedFirstTrainingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLeadVisitedFirstTrainingMutation(baseOptions?: Apollo.MutationHookOptions<LeadVisitedFirstTrainingMutation, LeadVisitedFirstTrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LeadVisitedFirstTrainingMutation, LeadVisitedFirstTrainingMutationVariables>(LeadVisitedFirstTrainingDocument, options);
      }
export type LeadVisitedFirstTrainingMutationHookResult = ReturnType<typeof useLeadVisitedFirstTrainingMutation>;
export type LeadVisitedFirstTrainingMutationResult = Apollo.MutationResult<LeadVisitedFirstTrainingMutation>;
export type LeadVisitedFirstTrainingMutationOptions = Apollo.BaseMutationOptions<LeadVisitedFirstTrainingMutation, LeadVisitedFirstTrainingMutationVariables>;
export const NoviceVisitedFirstTrainingDocument = gql`
    mutation noviceVisitedFirstTraining($input: NoviceVisitedFirstTrainingInput!) {
  noviceVisitedFirstTraining(input: $input) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type NoviceVisitedFirstTrainingMutationFn = Apollo.MutationFunction<NoviceVisitedFirstTrainingMutation, NoviceVisitedFirstTrainingMutationVariables>;

/**
 * __useNoviceVisitedFirstTrainingMutation__
 *
 * To run a mutation, you first call `useNoviceVisitedFirstTrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNoviceVisitedFirstTrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [noviceVisitedFirstTrainingMutation, { data, loading, error }] = useNoviceVisitedFirstTrainingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNoviceVisitedFirstTrainingMutation(baseOptions?: Apollo.MutationHookOptions<NoviceVisitedFirstTrainingMutation, NoviceVisitedFirstTrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NoviceVisitedFirstTrainingMutation, NoviceVisitedFirstTrainingMutationVariables>(NoviceVisitedFirstTrainingDocument, options);
      }
export type NoviceVisitedFirstTrainingMutationHookResult = ReturnType<typeof useNoviceVisitedFirstTrainingMutation>;
export type NoviceVisitedFirstTrainingMutationResult = Apollo.MutationResult<NoviceVisitedFirstTrainingMutation>;
export type NoviceVisitedFirstTrainingMutationOptions = Apollo.BaseMutationOptions<NoviceVisitedFirstTrainingMutation, NoviceVisitedFirstTrainingMutationVariables>;
export const LeadsForTrainingDocument = gql`
    query leadsForTraining($training: ID!) {
  leadsForTraining(training: $training) {
    description
    id
    name
    nextVisit {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
    }
    nextVisitId
    phone
    published
    source
    status
    student {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
    }
    studentId
    staff {
      birthday
      department
      description
      fileName
      id
      name
      orderNumber
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      work
    }
    staffId
    team {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    teamId
    yearBorn
  }
}
    `;

/**
 * __useLeadsForTrainingQuery__
 *
 * To run a query within a React component, call `useLeadsForTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useLeadsForTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLeadsForTrainingQuery({
 *   variables: {
 *      training: // value for 'training'
 *   },
 * });
 */
export function useLeadsForTrainingQuery(baseOptions: Apollo.QueryHookOptions<LeadsForTrainingQuery, LeadsForTrainingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LeadsForTrainingQuery, LeadsForTrainingQueryVariables>(LeadsForTrainingDocument, options);
      }
export function useLeadsForTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LeadsForTrainingQuery, LeadsForTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LeadsForTrainingQuery, LeadsForTrainingQueryVariables>(LeadsForTrainingDocument, options);
        }
export type LeadsForTrainingQueryHookResult = ReturnType<typeof useLeadsForTrainingQuery>;
export type LeadsForTrainingLazyQueryHookResult = ReturnType<typeof useLeadsForTrainingLazyQuery>;
export type LeadsForTrainingQueryResult = Apollo.QueryResult<LeadsForTrainingQuery, LeadsForTrainingQueryVariables>;
export function refetchLeadsForTrainingQuery(variables: LeadsForTrainingQueryVariables) {
      return { query: LeadsForTrainingDocument, variables: variables }
    }
export const UpdateLeadCancelFirstTrainingDocument = gql`
    mutation updateLeadCancelFirstTraining($id: ID!) {
  updateLeadCancelFirstTraining(id: $id) {
    record {
      description
      id
      name
      nextVisit {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      nextVisitId
      phone
      published
      source
      status
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
      }
      studentId
      staff {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      staffId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      yearBorn
    }
    recordId
    errors {
      ... on LeadDoesNotExistsProblem {
        message
      }
      ... on LeadExistInOtherComponentsProblem {
        component
        message
      }
      ... on LeadSaveProblem {
        message
      }
      ... on LeadUpdateProblem {
        message
      }
    }
  }
}
    `;
export type UpdateLeadCancelFirstTrainingMutationFn = Apollo.MutationFunction<UpdateLeadCancelFirstTrainingMutation, UpdateLeadCancelFirstTrainingMutationVariables>;

/**
 * __useUpdateLeadCancelFirstTrainingMutation__
 *
 * To run a mutation, you first call `useUpdateLeadCancelFirstTrainingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLeadCancelFirstTrainingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLeadCancelFirstTrainingMutation, { data, loading, error }] = useUpdateLeadCancelFirstTrainingMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateLeadCancelFirstTrainingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLeadCancelFirstTrainingMutation, UpdateLeadCancelFirstTrainingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLeadCancelFirstTrainingMutation, UpdateLeadCancelFirstTrainingMutationVariables>(UpdateLeadCancelFirstTrainingDocument, options);
      }
export type UpdateLeadCancelFirstTrainingMutationHookResult = ReturnType<typeof useUpdateLeadCancelFirstTrainingMutation>;
export type UpdateLeadCancelFirstTrainingMutationResult = Apollo.MutationResult<UpdateLeadCancelFirstTrainingMutation>;
export type UpdateLeadCancelFirstTrainingMutationOptions = Apollo.BaseMutationOptions<UpdateLeadCancelFirstTrainingMutation, UpdateLeadCancelFirstTrainingMutationVariables>;